/*
 *
 *  A module for Window Height
 *
 */

export function windowheight(link, target, active) {
  window.addEventListener("resize", displayWindowSize, { passive: true });

  displayWindowSize();

  function displayWindowSize() {
    var h = document.documentElement.clientHeight;

    const attrremove = [
      "h1200",
      "h1100",
      "h1000",
      "h900",
      "h800",
      "h700",
      "h600",
      "h500",
    ];
    document.documentElement.classList.remove(...attrremove);

    let attr = [];

    if (h >= 1200) {
      attr.push("h1200");
    }

    if (h >= 1100) {
      attr.push("h1100");
    }

    if (h >= 1000) {
      attr.push("h1000");
    }

    if (h >= 900) {
      attr.push("h900");
    }

    if (h >= 800) {
      attr.push("h800");
    }

    if (h >= 700) {
      attr.push("h700");
    }

    if (h >= 600) {
      attr.push("h600");
    }

    if (h >= 500) {
      attr.push("h500");
    }

    if (h >= 400) {
      attr.push("h500");
    }

    attr.forEach(function (att, index) {
      document.documentElement.classList.add(att);
    });
  }
}
